#import "../../../../../../../common/graphql/EntityUserMessageFields.graphql"

query BatchTransactionMessagesView(
  $id: UUID!
  $first: Int
  $after: Cursor
  $filter: UserMessageFilter
) {
  batchTransaction(id: $id) {
    id
    userMessagesByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
      filter: $filter
    ) {
      nodes {
        ...EntityUserMessageFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
